import { useMutation, useQueryClient } from '@tanstack/react-query';

import { TeamBoardCreateReq, teamApi } from '../api';
import { TEAM_DETAIL_QUERY_KEY, TEAM_TASKS_QUERY_KEY } from '../queries';

interface CreateTeamBoardParams {
  teamId: string;
  teamBoardCreateReq: TeamBoardCreateReq;
}

export const useCreateTeamBoard = () => {
  const queryClient = useQueryClient();

  const createTeamBoardMutation = useMutation({
    mutationFn: ({ teamId, teamBoardCreateReq }: CreateTeamBoardParams) => {
      return teamApi.createTeamBoard(teamId, teamBoardCreateReq).then(({ data }) => data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TEAM_DETAIL_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: TEAM_TASKS_QUERY_KEY });
    },
  });

  return {
    createTeamBoard: createTeamBoardMutation.mutateAsync,
    isCreatingTeamBoard: createTeamBoardMutation.isPending,
    ...createTeamBoardMutation,
  };
};
